import { render, staticRenderFns } from "./UserAccountTab.html?vue&type=template&id=50629cb1&scoped=true&"
import script from "./UserAccountTab.ts?vue&type=script&lang=ts&"
export * from "./UserAccountTab.ts?vue&type=script&lang=ts&"
import style0 from "./UserAccountTab.scss?vue&type=style&index=0&id=50629cb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50629cb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
